import React from "react";

export default function Recruitment() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Recruitment</h1>
      <p>This is the Recruitment page. Manage job openings, applicants, and recruitment workflow here.</p>
      {/* Add job posting table or application list here */}
    </div>
  );
}
